import { render } from "./PagesContactsItem.vue?vue&type=template&id=6d8c418e&scoped=true"
import script from "./PagesContactsItem.vue?vue&type=script&lang=js"
export * from "./PagesContactsItem.vue?vue&type=script&lang=js"

import "./PagesContactsItem.vue?vue&type=style&index=0&id=6d8c418e&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8c418e"]])

export default __exports__